import React, { useState } from 'react';
import {
  Grid
} from "semantic-ui-react";
import Vimeo from '@u-wave/react-vimeo';
import AddTitleBar from '../../components/titleBar/add_titleBar';

function Tutorial(props) {

  const tutorialObj = [
    { name: 'Partner Responding on Indents', link: 'https://vimeo.com/667630553' },
    { name: 'Vehicle Details Update', link: 'https://vimeo.com/667630714' },
    { name: 'Vehicle Reporting', link: 'https://vimeo.com/667630877' },
    { name: 'Billing', link: 'https://vimeo.com/667630595' },
    { name: 'Vehicle Availability', link: 'https://vimeo.com/667630751' },
    { name: 'Billing Status', link: 'https://vimeo.com/667630665' }
  ]
  return (
    <React.Fragment>
      <AddTitleBar Title="Tutorials" LinkName="/tutorial" />
      <div className="ag-theme-material agOver animated slideInDown spacing-tutorial style">

        <Grid
          columns={2}
          stackable
          className="adjust-video-tutorial"
        >
          {tutorialObj.map((item, index) => {
            return (
              <>
                <Grid.Column className="text-center padding-bottom-40 adjust-video">
                  <a className="video-header" href={item.link} target="_blank">{item.name}</a>
                  <Vimeo
                    video={item.link}
                    autoplay={false}
                  />
                </Grid.Column>
              </>
            )
          })}
        </Grid>
      </div>
    </React.Fragment>
  )
}


export default Tutorial